import React, { useState } from 'react';
import { Info } from 'lucide-react';

const Input = ({
    label,
    name,
    value,
    handleChange,
    error,
    type = 'text',
    required = false,
    tooltip,
    pattern,
    placeholder,
    helperText,
    min,
    max
}) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="form-group">
            <label className="form-label text-muted text-start w-100">
                {label}
                {required && <span className="text-danger ms-1">*</span>}
                {tooltip && (
                    <span
                        className="ms-2 text-primary cursor-pointer"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                    >
                        <Info size={16} />
                    </span>
                )}
            </label>
            {showTooltip && (
                <div className="tooltip-custom bg-light p-2 rounded border mb-2">
                    {tooltip}
                </div>
            )}
            <input
                type={type}
                className={`form-control bg-light ${error ? 'is-invalid' : ''}`}
                name={name}
                value={value || ''}
                onChange={handleChange}
                pattern={pattern}
                placeholder={placeholder}
                min={min}
                max={max}
            />
            {helperText && !error && (
                <small className="text-muted d-block mt-1 text-start">
                    {helperText}
                </small>
            )}
            {error && (
                <div className="invalid-feedback d-block text-start">
                    {error}
                </div>
            )}
            <style jsx="true">{`
                .form-group {
                    position: relative;
                    margin-bottom: 0.5rem;
                }
                .invalid-feedback {
                    display: none;
                }
                .invalid-feedback.d-block {
                    display: block !important;
                    color: #dc3545;
                    font-size: 0.875em;
                    margin-top: 0.25rem;
                }
                .form-control.is-invalid {
                    border-color: #dc3545;
                    padding-right: calc(1.5em + 0.75rem);
                    background-position: right 0.75rem center;
                }
            `}</style>
        </div>
    );
};

export default Input;